* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #root {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

/* Custom scrollbars — dark theme */
* {
  scrollbar-width: thin;
  scrollbar-color: #2a2d35 transparent;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #2a2d35;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #3a3e48;
}
::-webkit-scrollbar-corner {
  background: transparent;
}

/* Mobile: horizontal scroll for tables, touch targets, prevent zoom */
@media (max-width: 767px) {
  table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  thead, tbody, tr {
    display: table;
    width: 100%;
    table-layout: auto;
  }
  button, select, input, a {
    min-height: 44px;
  }
  input[type="number"], input[type="text"], input[type="email"], input[type="password"], input[type="date"], select, textarea {
    font-size: 16px !important;
  }
}
